module.exports = __webpack_public_path__ + "static/media/davivienda.42dad84f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/payment-method/davivienda.png
// module id = 1996
// module chunks = 0